export default __webpack_public_path__ + "static/media/store.6e85a15a.svg";